import styled from "styled-components";

const ContainerToggleConfigurar = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;

  label {
    margin: 0;
  }

  .nome {
    width: 25rem;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
    
    span {
      display: inline-block;
    }
    
    .locked {
      margin-left: 1rem;
      color: ${(props) => props.theme.colors.alert || "#ff4a4a"};
      font-weight: 400;

      &::after{
        left: 0;
      }
    }
    
    svg{
      width: 4rem;
      height: 4rem;
    }
  }

  .configurar {
    transition: 500ms;
    color: ${(props) =>
      props.theme.colors.elements}; // assuming elements is part of the theme
    margin-left: 1rem;
  }

  .ativo {
    cursor: pointer;
    color: ${(props) =>
      props.theme.colors
        .primary}; // assuming primary is part of the theme
  }
`;

export default ContainerToggleConfigurar;
